<template v-if="allowUpload || allowDelete">
  <div>
    <dx-file-uploader ref="fileUploader"
      label-text=""
      :accept="accept"
      :allowed-file-extensions="allowedFileExtensions"
      upload-mode="useButtons"
      :upload-url="uploadUrl"
      :upload-headers="authorizationHeader"
      :show-file-list="false"
      :visible="false"
      @valueChanged="valueChanged"
      @uploaded="onUploaded"
      @upload-error="onUploadFailed"
    />

    <b-button class="mt-3" variant="secondary" size="sm" :disabled="disabled"
              @click="selectFile()" v-if="allowUpload">
      <font-awesome-icon :icon="['fas', 'folder-open']" /> {{ $t('Webportal.SelectFile') }}
    </b-button>

    <b-button class="mt-3" variant="secondary" size="sm" :disabled="disabled"
              @click="deleteFile()" v-if="allowDelete">
      <font-awesome-icon :icon="['fas', 'trash-alt']" /> {{ $t('Webportal.Delete') }}
    </b-button>
  </div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import { DxFileUploader } from 'devextreme-vue';
import axios from 'axios';

export default {
  name: "Uploader",

  props: {
    uploadUrl: {
      type: String,
      default: '/'
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    allowedFileExtensions: {
      type: Array,
      default: () => ['.jpg', '.jpeg', '.gif', '.png']
    },
    allowDelete: {
      type: Boolean,
      default: true
    },
    allowUpload: {
      type: Boolean,
      default: true
    },
    valueChanged: {
      type: Function,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  components : {
    DxFileUploader
  },

  data() {
    return {
      uploadFinished: () => {},
      uploadFailed: () => {}
    };
  },

  computed: {
    authorizationHeader() {
      return AuthenticationService.authorizationHeader;
    }
  },

  methods: {
    reset() {
      this.$refs.fileUploader.instance.reset();
    },

    selectFile() {
      let selectButton = this.$refs.fileUploader.$el
        .getElementsByClassName("dx-fileuploader-input-wrapper")[0]
        .getElementsByClassName("dx-fileuploader-button");

      if (selectButton)
      {
        selectButton[0].click();
      }
    },

    deleteFile() {
      this.$refs.fileUploader.instance.reset();
      this.$emit('input', null);
    },

    uploadFile() {
      let fileUploader = this.$refs.fileUploader;

      if (fileUploader.instance._files.length > 0)
      {
        // Enable retry
        for (var i = 0; i < fileUploader.instance._files.length; i++) {
          delete fileUploader.instance._files[i].uploadStarted;
        }

        let uploadButton = fileUploader.$el.getElementsByClassName("dx-fileuploader-button dx-fileuploader-upload-button");
        if (uploadButton) {
          uploadButton[0].click();

          // Make promise resolvable externally
          return new Promise((resolve, reject) => {
            this.uploadFinished = resolve;
            this.uploadFailed = reject;
          });
        }
      }
      else
      {
        // Delete picture
        return axios.post(this.uploadUrl);
      }

      return Promise.reject();
    },

    onUploaded(e) {
      if (this.uploadFinished instanceof Function)
        this.uploadFinished(e);
    },

    onUploadFailed(e) {
      if (this.uploadFailed instanceof Function)
        this.uploadFailed(e);
    }
  }
}
</script>